import React, { Component } from "react";
import { Row, Col, Panel, Alert } from "react-bootstrap";
import Loader from "src/js/Loader.js";
import { Bar } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { msgs } from "src/js/ErrorMessage.js";
import 'src/i18n';
import { withTranslation } from 'react-i18next';

class RankingMonthlyGraph extends Component {
  constructor(prop) {
    super(prop);
    this.createChartData = this.createChartData.bind(this);
  }

  createChartData() {
    return {
      labels: this.props.labels,
      datasets: [
        {
          type: "line",
          label: "yours",
          borderColor: "rgba(10,10,255,0.3)",
          backgroundColor: "rgba(10,10,255,0.3)",
          fill: false,
          lineTension: 0.1,
          pointRadius: 2,
          pointHoverRadius: 3,
          pointHoverBackgroundColor: "rgba(10,10,255,0.3)",
          pointHoverBorderColor: "rgba(10,10,255,0.3)",
          data: this.props.data,
          datalabels: {
            font: {
              weight: "bold",
            },
            anchor: "start",
            align: "start",
          },
        },
      ],
    };
  }

  render() {
    const {t} = this.props;
    const Error = () => (
      <div>
        {(() => {
          return (
            <Alert bsStyle="danger">
              <p>{t("Message." + msgs["msg_common_01"])}</p>
            </Alert>
          );
        })()}
      </div>
    );

    const chartOptions = {
      plugins: [ChartDataLabels],
      hover: {
        mode: "index",
        intersect: false,
      },
      scales: {
        // y軸の最小値、最大値を設定
        yAxes: [
          {
            ticks: {
              reverse: true,
              beginAtZero: true,
              min: 1,
              max: this.props.maxYAxes,
              stepSize: 10,
            },
          },
        ],
        xAxes: [
          {
            // x軸のgrid線を非表示
            gridLines: {
              drawOnChartArea: false,
            },
          },
        ],
      },
      tooltips: {
        mode: "index",
        intersect: false,
        enabled: false,
        callbacks: {
          labelColor: function (tooltipItem, chart) {
            let index = tooltipItem.datasetIndex;
            let data = chart.config.data.datasets[index];
            return {
              borderColor: data.borderColor,
              backgroundColor: data.backgroundColor,
            };
          },
        },
      },
      legend: {
        display: false,
      },
    };

    return (
      <Row>
        <Col md={12} xs={12}>
          {
            // ローディング判定
            this.props.loading ? (
              <Panel>
                <Loader />
              </Panel>
            ) : // データ取得判定
            this.props.isData ? (
              <Panel>
                <h4 id="graph-title">{t('Ranking.YourTrend')}</h4>
                <Bar data={this.createChartData} options={chartOptions} />
              </Panel>
            ) : (
              // 失敗
              <Error />
            )
          }
        </Col>
      </Row>
    );
  }
}

export default withTranslation()(RankingMonthlyGraph);


// WEBPACK FOOTER //
// ./src/component/Ranking/RankingMonthlyGraph.js